export default "__VITE_ASSET__BmCBU6_M__"